export class CustomerFilter {
  public DisplayName: string;
  public Code: string;
  public PhoneNumber: string;
  public Address: string;
}
